<template>
  <div style="padding: 10px;background:white;height:768px">
    
  </div>
</template>

<script>
export default {
  name: "T1",
  data() {
    return {
      tableHeight: "200",
      border: [],
      password: {}
    };
  },
  methods: {

    onDownMessage() {
      console.log(this.border);
      this.downMessage();
    },
    
    updatePassword() {
      var that = this;
      if(that.password.new2 == undefined || that.password.new2 == "" || that.password.new1 == undefined || that.password.new1 == "" || that.password.old == undefined || that.password.old == ""){
        that.$Modal.info({
            title: "提示",
            content: "请输入正确的信息"
        });
        return;
      }
      if(that.password.new1 != that.password.new2){
        that.$Modal.info({
            title: "提示",
            content: "两次输入的新密码不相同"
        });
        return;
      }

      this.$axios
        .post("/api/user/updatePassword", {
          oldPwd: that.password.old,
          newPwd: that.password.new2
        })
        .then(function(res) {
          console.log(res);
          if(res.errorCode == 0){
            that.$Modal.success({
                title: "提示",
                content: "密码修改成功"
            });
          }else{
            that.$Modal.warning({
                title: "提示",
                content: res.errorInfo
            });
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  },
  mounted() {
    // this.showPage();
    let that = this;
    window.addEventListener("resize", function() {
      that.tableHeight = (window.innerHeight - 186) * 0.8;
    });
    that.tableHeight = (window.innerHeight - 186) * 0.8;
  }
};
</script>

<style scoped>
</style>